import React, {Fragment, useContext} from "react";
import {View, Text} from "@react-pdf/renderer";
import PropTypes from "prop-types";

import {
  detectComplexLaborCartItem,
  getPriceWithCurrency, getTotalPrice,
  toFixedFeatureCost,
  toFixedPrice
} from "../../../misc/helpers";
import {PrintDocumentContext} from "./printDocumentContext";
import {getCartItemName, getFeatureUnit} from "./printDocumentFunctions";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import {SQFT_FEATURES} from "../../sqft/constants";
import {getPriceWithIncluded, getShowPrice} from "../../../misc/priceFunctions";
import PrintDocumentBodyBundledCartItems from "./printDocumentBodyBundledCartItems";

const PrintDocumentBodyCartItem = (props) => {
  const {styles, cartItem, fabricatorData, locale, cartItems} = props;
  const fabricatorSettings = fabricatorData.settings;
  const isComplexMultipliedUsed = detectComplexLaborCartItem(cartItem) && getTotalPrice().multipliedCostUsed;
  const priceTotal = isComplexMultipliedUsed || cartItem.displayFakePrice === 0
    ? null
    : toFixedFeatureCost(cartItem.cartFeature, cartItem.quantity, cartItem.fromQtCategory, true, cartItem, cartItem.partId === SQFT_FEATURES.slabs, cartItem.currentQuote);
  const printContext = useContext(PrintDocumentContext);

  const getFeatureQuantity = () => {
    return printContext.messages["receipt.content.featureQuantity"] || ""
  };

  const getPrice = () => {
    const showPrice = getShowPrice(fabricatorData);
    if (!showPrice) {
      return null
    }
    return getPriceWithIncluded(priceTotal, cartItem.cartFeature, fabricatorData, printContext.messages)
  };

  const featurePrice = toFixedFeatureCost(cartItem.cartFeature, 1, cartItem.fromQtCategory, false, null, cartItem.partId === SQFT_FEATURES.slabs, cartItem.currentQuote);
  const price = getPrice();
  const hideUnitPrice = (cartItem.partId === "room" && !featurePrice) || !price;
  const isMinimumCharge = cartItem.isMinimumCharge && !cartItem.isMinimumChargeItems;
  const displayFake = cartItem.displayFakeQuantity && (typeof cartItem.displayFakeQuantity === "number") && (cartItem.displayFakeQuantity > 0);

  const bundleProducts = cartItems ? cartItems.filter(cItem => {
    return cItem.bundleParentId && (cItem.bundleParentId === cartItem.id)
  }) : [];

  return (
    <Fragment>
      <View style={styles.cartItem} wrap={true}>
        <View wrap={false}>
          <Text style={isMinimumCharge ? [styles.cartItemName, styles.cartItemNameCentered] : styles.cartItemName}>
            {getCartItemName(cartItem.cartFeature, fabricatorData, printContext, locale)}
          </Text>
          <View style={styles.cartItemInfo}>
            {cartItem.cartFeature.dbFeature.sku && !fabricatorSettings.hideSku ? (
              <Text style={[styles.cartItemUnit, styles.cartItemUnitSKU]}>
                {`${printContext.messages["receipt.content.featureSKU"]}: ${cartItem.cartFeature.dbFeature.sku}`}
              </Text>
            ) : null}
            {isMinimumCharge || fabricatorData.hideCheckoutBreakdownCost
              ? null
              : (
                <Text style={styles.cartItemUnit}>
                  {`${getFeatureQuantity()}: ${toFixedPrice(displayFake ? cartItem.displayFakeQuantity : cartItem.quantity)}`}
                </Text>
              )}
            <Text style={styles.cartItemUnitItem}>
              {hideUnitPrice || isMinimumCharge
                ? null
                : `${getFeatureUnit(cartItem.cartFeature, fabricatorData, printContext, locale, cartItem.quantity)}: ${getPriceWithCurrency(fabricatorSettings, featurePrice, cartItem.cartFeature)}`}
            </Text>
            <Text style={styles.cartItemPrice}>{price}</Text>
          </View>
          {cartItem.noteText ? <Text style={styles.cartItemNote}>{cartItem.noteText}</Text> : null}
        </View>
      </View>
      {bundleProducts.length ? <PrintDocumentBodyBundledCartItems locale={locale}
                                                                  cartItems={cartItems}
                                                                  cartItem={cartItem}
                                                                  fabricatorData={fabricatorData}
                                                                  styles={styles}/> : null}
    </Fragment>

  )
};

PrintDocumentBodyCartItem.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  fabricatorData: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentBodyCartItem
